module.exports = __webpack_public_path__ + "img/fourday_ps_13.edffe5be.jpg";